import { render } from "./Topup2c2pDetail.vue?vue&type=template&id=f94eb780&scoped=true"
import script from "./Topup2c2pDetail.vue?vue&type=script&lang=js"
export * from "./Topup2c2pDetail.vue?vue&type=script&lang=js"

import "./Topup2c2pDetail.vue?vue&type=style&index=0&id=f94eb780&lang=scss&scoped=true"

import exportComponent from "H:\\git\\Net_Web_LandingVue\\vue-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f94eb780"]])

export default __exports__